import { handleProcessReportGroupResults } from './handle-process-report-group-results.js';
import { processBooleanGroup } from './process-boolean-group.js';
import { processConnectionGroup } from './process-connection-group.js';
import { processMultipleChoiceGroup } from './process-multiplechoice-group.js';
import { processSQLDateTimeGroup } from './process-sql-datetime-group.js';
export const ReportHelper = {
    processMultipleChoiceGroup,
    processBooleanGroup,
    processConnectionGroup,
    handleProcessReportGroupResults,
    processSQLDateTimeGroup
};
